import React from 'react';
import I18n from 'app/i18n';
import wheelUrl from 'images/landing-affiliates/wheel.svg';
import {ArrowIcon} from './AffiliatesIcons';
import {PARTNER_REGISTER_URL} from './affiliatesLinks';

const AffiliatesCta = (): React.ReactElement => <section className="sec cta-sec">
    <div className="wrap">
        <div className="cta rv">
            <div className="wheel" aria-hidden="true">
                <img className="spin" src={wheelUrl} alt=""/>
            </div>
            <div>
                <h2 dangerouslySetInnerHTML={{__html: I18n.t('affiliate.cta_h')}}/>
            </div>
            <a className="btn" id="ctaBtn" href={PARTNER_REGISTER_URL}>
                <span>{I18n.t('affiliate.join')}</span>
                <ArrowIcon/>
            </a>
        </div>
    </div>
</section>;

export default AffiliatesCta;
